import { Component } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { Router } from "@angular/router";
import { FirebaseAuthService } from "@services/index";

/**
 * Shown instead of a plain login error whenever a Google or email-code login
 * succeeds (the account itself is real) but it already exists as something
 * other than admin (a regular customer or vendor). Self-service sign-in
 * deliberately never promotes an existing non-admin account, even to a
 * pending/inactive admin row — that stays a dead end by design; only an
 * existing admin, via the user-management UI, can promote the account.
 * (A brand-new email with no prior row instead gets a pending-activation
 * admin row created automatically — see the login component's other branch.)
 */
@Component({
  selector: "fh-request-admin-access",
  templateUrl: "./request-admin-access.component.html",
  styleUrls: ["./request-admin-access.component.css"],
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
})
export class RequestAdminAccessComponent {
  signedInEmail: string | null;

  constructor(
    private router: Router,
    private firebaseAuth: FirebaseAuthService
  ) {
    // Read via history.state (set synchronously by Router.navigate's `state` extra)
    // rather than getCurrentNavigation(), which is only reliably non-null while a
    // navigation is actively in flight, not once this component has been activated.
    this.signedInEmail = (history.state?.email as string) ?? null;
  }

  async tryDifferentAccount() {
    await this.firebaseAuth.signOutGoogle();
    this.router.navigate(["/login"]);
  }
}
